
import { AppState } from '@/types';
import { getAllBadges } from '@/lib/badgeSystem';
import { getTiers } from '@/lib/tierSystem';

export const createStatsActions = (state: AppState, dispatch: any, setAppState: any) => {
  const resetMonthlyStats = async (): Promise<void> => {
    console.log('🗓️ RESET_MONTHLY_STATS action dispatched - current state:', {
      totalPoints: state.totalPoints,
      currentMonthPoints: state.currentMonthPoints,
      activitiesCount: state.activities.length,
      userId: state.user?.id
    });
    
    // Dispatch the reset action
    dispatch({ type: 'RESET_MONTHLY_STATS' });
    
    // Wait a moment for the reducer to update state, then force save to database
    setTimeout(async () => {
      try {
        console.log('🗓️ Forcing database sync after monthly reset...');
        await setAppState(prevState => ({
          ...prevState,
          currentMonthPoints: 0,
          monthlyStartDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        }));
        console.log('🗓️ Monthly reset database sync completed');
      } catch (error) {
        console.error('❌ Failed to sync monthly reset to database:', error);
      }
    }, 500);
    
    console.log('🗓️ Monthly stats reset completed');
  };
  const resetWeeklyStats = async (): Promise<void> => {
    console.log('🔄 RESET_WEEKLY_STATS action dispatched - current state:', {
      totalPoints: state.totalPoints,
      currentWeekPoints: state.currentWeekPoints,
      activitiesCount: state.activities.length,
      userId: state.user?.id
    });
    
    // Dispatch the reset action
    dispatch({ type: 'RESET_WEEKLY_STATS' });
    
    // Wait a moment for the reducer to update state, then force save to database
    setTimeout(async () => {
      try {
        console.log('🔄 Forcing database sync after weekly reset...');
        await setAppState(prevState => ({
          ...prevState,
          currentWeekPoints: 0,
          activitiesLoggedToday: 0,
          activityCounts: {
            'Closed': 0,
            'Opening': 0,
            'Set': 0,
            'Hangout': 0,
            'Story': 0,
            'Roleplay': 0,
            'Call': 0,
            'Admin': 0,
            'Closing': 0,
            'Referral': 0,
            'Client Servicing': 0
          }
        }));
        console.log('🔄 Weekly reset database sync completed');
      } catch (error) {
        console.error('❌ Failed to sync weekly reset to database:', error);
      }
    }, 500);
    
    console.log('🔄 Weekly stats reset completed - leaderboards will update via real-time subscriptions');
  };

  const getBadges = () => {
    return getAllBadges(state) || [];
  };

  return {
    resetWeeklyStats,
    resetMonthlyStats,
    getAllBadges: getBadges,
    getTiers
  };
};
